import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=50b48464&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
import style0 from "./Join.vue?vue&type=style&index=0&id=50b48464&prod&lang=scss&scoped=true"
import style1 from "./Join.vue?vue&type=style&index=1&id=50b48464&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b48464",
  null
  
)

export default component.exports